import { MutationTree } from "vuex";
import { PreviewState } from "@/services/preview/types";

export const mutations: MutationTree<PreviewState> = {
    setPreviewControlStatus(state) {
        state.previewControlsStatus = !state.previewControlsStatus;
    }
};
